import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { init, sendPageView } from '@/lib/ga4';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = document.title;

    sendPageView(path, title);
  }, [location]);
}

export default useGoogleAnalytics;
